import { GET_WEBHOOKS, GET_SPECIFIC_WEBHOOK, GET_ALL_ROUTES, GET_ALL_QUEUES, GET_ALL_AGENTS, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

export default {
  [GET_WEBHOOKS]: (state, webhooks) => {
    state.webhooks = webhooks
  },
  [GET_SPECIFIC_WEBHOOK]: (state, webhook) => {
    state.webhook = webhook
  },
  [GET_ALL_ROUTES]: (state, rotas) => {
    state.rotas = rotas
  },
  [GET_ALL_QUEUES]: (state, filas) => {
    state.filas = filas
  },
  [GET_ALL_AGENTS]: (state, operadores) => {
    state.operadores = operadores
  },
  [LISTAR_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
  },
}
